
export const headerData = {
    name: 'Kanav Sharma',
    title: "",
    desciption: "",
    image: '',
    imagebw: '',
    resumePdf: 'https://docs.google.com/document/d/1OmxnrxHbrfQkL7e3BG40HgSmYCWzNSxo9Wa-kOPVPSc/edit?usp=sharing'
}
